var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        [
          _c("v-data-table", {
            staticClass: "templates-table",
            attrs: {
              headers: _vm.headers,
              items: _vm.templates,
              loading: _vm.loading,
              "item-key": "template_id",
              "item-class": _vm.rowClass,
              "hide-default-footer": "",
              "no-data-text": "No export templates yet"
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item.columns",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            item.config && item.config.fields
                              ? item.config.fields.length
                              : 0
                          ) +
                          "\n      "
                      )
                    ]
                  }
                },
                {
                  key: "item.filters",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.filterSummary(item)) +
                          "\n      "
                      )
                    ]
                  }
                },
                {
                  key: "item.updated_on",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.formatDate(item.updated_on)) +
                          "\n      "
                      )
                    ]
                  }
                },
                {
                  key: "item.actions",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        {
                                          staticClass: "mr-3",
                                          attrs: { small: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.editTemplate(item)
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_vm._v("mdi-pencil")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" "), _c("span", [_vm._v("Edit")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        {
                                          staticClass: "mr-3",
                                          attrs: { small: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.duplicateTemplate(item)
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_vm._v("mdi-content-copy")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" "), _c("span", [_vm._v("Duplicate")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        {
                                          attrs: { small: "", color: "error" },
                                          on: {
                                            click: function($event) {
                                              return _vm.promptDelete(item)
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_vm._v("mdi-delete")]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" "), _c("span", [_vm._v("Delete")])]
                      )
                    ]
                  }
                }
              ],
              null,
              true
            )
          }),
          _vm._v(" "),
          _c("v-divider", { staticClass: "mt-4 mb-4" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "template-form" },
            [
              _c("div", { staticClass: "subtitle-2 mb-2" }, [
                _vm._v(_vm._s(_vm.editingId ? "Edit template" : "New template"))
              ]),
              _vm._v(" "),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Template name",
                          dense: "",
                          outlined: "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex align-center mt-3 mb-1" },
                [
                  _c(
                    "span",
                    { staticClass: "caption grey--text text--darken-1" },
                    [_vm._v("Columns")]
                  ),
                  _vm._v(" "),
                  _c("v-checkbox", {
                    staticClass: "mt-0 pt-0 ml-4",
                    attrs: {
                      "input-value": _vm.allColumnsSelected,
                      indeterminate:
                        _vm.someColumnsSelected && !_vm.allColumnsSelected,
                      label: "Select all",
                      dense: "",
                      "hide-details": ""
                    },
                    on: { change: _vm.toggleAllColumns }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                _vm._l(_vm.detailSelectionList, function(detail, index) {
                  return _c(
                    "v-col",
                    { key: index, attrs: { cols: "3" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "mt-0",
                        attrs: {
                          value: detail.id,
                          label: detail.label,
                          dense: "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.form.fieldIds,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "fieldIds", $$v)
                          },
                          expression: "form.fieldIds"
                        }
                      })
                    ],
                    1
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "caption mt-3 mb-1 grey--text text--darken-1" },
                [_vm._v("Filters (optional)")]
              ),
              _vm._v(" "),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.userSources,
                          "item-text": "display_name",
                          "item-value": "source_id",
                          label: "Sources",
                          multiple: "",
                          "small-chips": "",
                          dense: "",
                          outlined: "",
                          "hide-details": "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.form.filters.item_sources,
                          callback: function($$v) {
                            _vm.$set(_vm.form.filters, "item_sources", $$v)
                          },
                          expression: "form.filters.item_sources"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Description contains",
                          dense: "",
                          outlined: "",
                          "hide-details": "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.form.filters.description,
                          callback: function($$v) {
                            _vm.$set(_vm.form.filters, "description", $$v)
                          },
                          expression: "form.filters.description"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.departmentOptions,
                          label: "Departments",
                          multiple: "",
                          "small-chips": "",
                          dense: "",
                          outlined: "",
                          "hide-details": "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.form.filters.departments,
                          callback: function($$v) {
                            _vm.$set(_vm.form.filters, "departments", $$v)
                          },
                          expression: "form.filters.departments"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.categoryOptions,
                          label: "Categories",
                          multiple: "",
                          "small-chips": "",
                          dense: "",
                          outlined: "",
                          "hide-details": "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.form.filters.categories,
                          callback: function($$v) {
                            _vm.$set(_vm.form.filters, "categories", $$v)
                          },
                          expression: "form.filters.categories"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.subcategoryOptions,
                          label: "Subcategories",
                          multiple: "",
                          "small-chips": "",
                          dense: "",
                          outlined: "",
                          "hide-details": "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.form.filters.subcategories,
                          callback: function($$v) {
                            _vm.$set(_vm.form.filters, "subcategories", $$v)
                          },
                          expression: "form.filters.subcategories"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.showStatus
                ? _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.statusOptions,
                              label: "Status",
                              dense: "",
                              outlined: "",
                              "hide-details": "",
                              clearable: ""
                            },
                            model: {
                              value: _vm.form.filters.status,
                              callback: function($$v) {
                                _vm.$set(_vm.form.filters, "status", $$v)
                              },
                              expression: "form.filters.status"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.otherFilterKeys.length
                ? _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pt-1", attrs: { cols: "12" } },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "caption grey--text text--darken-1"
                            },
                            [
                              _vm._v(
                                "\n            Also filters by: " +
                                  _vm._s(_vm.otherFilterLabel) +
                                  " (kept as saved)\n          "
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.error
                ? _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pt-0", attrs: { cols: "12" } },
                        [
                          _c("span", { staticClass: "error--text caption" }, [
                            _vm._v(_vm._s(_vm.error))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _vm._v(" "),
          _vm.editingId
            ? _c(
                "v-btn",
                {
                  staticClass: "mr-4",
                  attrs: { text: "" },
                  on: { click: _vm.resetForm }
                },
                [_vm._v("Cancel edit")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                loading: _vm.saving,
                disabled: !_vm.canSave
              },
              on: { click: _vm.saveTemplate }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.editingId ? "Update" : "Create") +
                  "\n    "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "420" },
          model: {
            value: _vm.showDeleteConfirm,
            callback: function($$v) {
              _vm.showDeleteConfirm = $$v
            },
            expression: "showDeleteConfirm"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "subtitle-1" }, [
                _vm._v("Delete export template?")
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v("\n        Delete "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.pendingDelete ? _vm.pendingDelete.name : "")
                  )
                ]),
                _vm._v(
                  "? Any\n        scheduled deliveries using it will be removed as well.\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function($event) {
                          _vm.showDeleteConfirm = false
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error", text: "" },
                      on: { click: _vm.confirmDelete }
                    },
                    [_vm._v("Delete")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fd79bcf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fd79bcf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExportTemplatesPanel.vue
// module id = null
// module chunks = 